/** Client logo filenames under /Images/clientele/ - single source for Clientele page and home strip */
export const CLIENT_LOGO_FILES = [
  'ewands-clientel-marriott.png',
  'ewands-clientel-daikin.png',
  'ewands-clientel-UEMSunrise.png',
  'ewands-clientel-petronas.png',
  'ewands-clientel-prudential.png',
  'ewands-clientel-suriaklcc.png',
  'ewands-clientel-citibank.png',
  'ewands-clientel-exytes.jpg',
  'ewands-clientel-sanovo.jpg',
  'ewands-clientel-a2-automation.jpg',
  'ewands-clientel-MalaysianGASAssociation.png',
  'ewands-clientel-joeyyap.png',
];

/** Home page shows the full set (grid handles layout) */
export const CLIENT_LOGO_FILES_HOME = CLIENT_LOGO_FILES;
